import { useMemo } from 'react';
import { shallowEqual, useSelector } from 'react-redux';

const usePersonalInformation = () => {
  const store = useSelector(({
    personalInformation,
  }) => ({ personalInformation }), shallowEqual);
  const { personalInformation } = store;

  const userInformation = useMemo(() => {
    const { userInfo } = personalInformation;
    if (!userInfo?.Address) {
      return {
        address: {
          city: '',
          line1: '',
          line2: '',
          stateId: '',
          zipCode: '',
        },
        customerOrcaId: 0,
        firstName: '',
        lastName: '',
      };
    }

    return {
      address: {
        city: userInfo.Address.City,
        line1: userInfo.Address.Line1,
        line2: userInfo.Address.Line2,
        stateId: userInfo.Address.StateId,
        zipCode: userInfo.Address.ZipCode,
      },
      customerOrcaId: parseInt(userInfo.OrcaID, 10),
      firstName: userInfo.FirstName,
      lastName: userInfo.LastName,
    };
  }, [personalInformation]);

  return { userInformation };
};

export { usePersonalInformation };
